<template>
  <section>
    <b-row class="match-height">
      <b-col md="4" class="altezza_min_card_utenti">        
        <b-card nobody border-variant="secondary">
          <b-card-body class="p-0">
            <b-card-title>Utenti</b-card-title>

            <div class="scrollable-container">
              <b-list-group flush>
                <b-list-group-item class="d-flex align-items-center" v-for="(user) in this.lista_utenti" :key="user.id">
                  <b-avatar
                    size="35"
                    variant="light-secondary"
                    badge
                    class="badge-minimal mr-1"
                    :badge-variant="user.availability_color"
                  >
                    <feather-icon
                      icon="UserIcon"
                      size="22"
                    />
                  </b-avatar>
                  <span>{{ user.user_name }} {{ user.user_surname }}</span>

                </b-list-group-item>

              </b-list-group>
            </div>

          </b-card-body>
        </b-card>

      </b-col>

      <b-col md="8">
        <b-card
          nobody 
          border-variant="secondary"
          class="card-statistics"
        >          
          <b-card-body class="p-0">
            <b-card-title>Aggiornamenti</b-card-title>

            <b-row align-v="center" class="altezza_bmedia_stastiche">
              <b-col
                md="4"
                cols="12"
                class="mb-3 mb-md-0"
              >
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      variant="light-info"
                    >
                      <feather-icon
                        size="24"
                        icon="UsersIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto mb-0">
                    <h4 class="font-weight-bolder mb-0">
                      {{ statistiche.leads }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      Lead
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                md="4"
                cols="12"
                class="mb-3 mb-md-0"
              >
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      variant="light-warning"
                    >
                      <feather-icon
                        size="24"
                        icon="CalendarIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto mb-0">
                    <h4 class="font-weight-bolder mb-0">
                      {{ statistiche.attivita }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      Attività
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                md="4"
                cols="12"
                class="mb-3 mb-md-0"
              >
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      variant="light-secondary"
                    >
                      <feather-icon
                        size="24"
                        icon="MailIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto mb-0">
                    <h4 class="font-weight-bolder mb-0">
                      {{ statistiche.email_da_leggere }}
                    </h4>
                    <b-card-text class="font-small-3 mb-0">
                      Email
                    </b-card-text>
                  </b-media-body>
                </b-media>
              </b-col>
              

            </b-row>
              
          </b-card-body>
        </b-card>
      </b-col>
      
    </b-row>

    <b-row class="match-height">
      <b-col md="4">
        <b-card nobody border-variant="secondary">
          <b-card-body class="p-0">
            <b-card-title>Server</b-card-title>
            <b-row align-v="center">
              <b-col
                xl="6"
                xs="12"
              >
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      variant="light-secondary"
                    >
                      <feather-icon
                        size="24"
                        icon="ServerIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto mb-0">
                    <h4 class="font-weight-bolder mb-0">
                      Modalità
                    </h4>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                xl="6"
                xs="6"
                class="posizione_mobile"
              >
                <span class="text-danger"><b-badge :variant="statusSeverDebug(statistiche.status_app)">{{ statistiche.status_app }}</b-badge></span>
              </b-col>

            </b-row>

          </b-card-body>
        </b-card>

      </b-col>
      
      <b-col md="4">
        <b-card nobody border-variant="secondary">
          <b-card-body class="p-0">
            <b-card-title>Hard disk</b-card-title>
            <b-row align-v="center">
              <b-col
                xl="6"
                xs="12"
              >
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      variant="light-secondary"
                    >
                      <feather-icon
                        size="24"
                        icon="HardDriveIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto mb-0">
                    <h4 class="font-weight-bolder mb-0">
                      Spazio
                    </h4>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                xl="6"
                xs="6"
                class="posizione_mobile"
              >
                <span class="text-danger"><b-badge variant="light-success">{{ statistiche.spazio_disco }}</b-badge></span>
              </b-col>

            </b-row>

          </b-card-body>
        </b-card>

      </b-col>
      
      <b-col md="4">
        <b-card nobody border-variant="secondary">
          <b-card-body class="p-0">
            <b-card-title>Ram</b-card-title>
            <b-row align-v="center">
              <b-col
                xl="6"
                xs="12"
              >
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-2"
                  >
                    <b-avatar
                      size="48"
                      variant="light-secondary"
                    >
                      <feather-icon
                        size="24"
                        icon="LayersIcon"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body class="my-auto mb-0">
                    <h4 class="font-weight-bolder mb-0">
                      Libera
                    </h4>
                  </b-media-body>
                </b-media>
              </b-col>

              <b-col
                xl="6"
                xs="6"
                class="posizione_mobile"
              >
                <span class="text-danger"><b-badge variant="light-success">{{ statistiche.ram_libera }}</b-badge></span>
              </b-col>

            </b-row>

          </b-card-body>
        </b-card>

      </b-col>
      
      

    </b-row>
    
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardTitle, BCardText, BImg, BAvatar, BListGroup, BListGroupItem, BAlert, BMedia, BMediaAside, BMediaBody, BBadge, } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard, 
    BCardBody, 
    BCardTitle, 
    BCardText,
    BAvatar,
    BImg,
    BListGroup, 
    BListGroupItem, 
    BAlert, 
    BMedia, 
    BMediaAside, 
    BMediaBody, 
    BBadge, 

  },
  data() {
    return {
      userData: {},
      lista_utenti: {},
      statistiche: {
        leads: 0,
        attivita: 0,
        email_da_leggere: 0,
        status_app: "",
        spazio_disco: "",
      },

      Caricato: false,
      errore_caricamento: false,

      intervalId: null, // ID per controllare l'intervallo

    }
  },
  computed: {
    statusSeverDebug() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Debug : 'light-danger',
        Produzione : 'light-success',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
  },
  created() {
    // dati reali
    this.userData = JSON.parse(localStorage.getItem('userData'))
    //console.log(this.userData)

    const listaUtenti = this.$http.get('api/crm/user/list_availabilities')
    const infoHome = this.$http.get('api/crm/homecrm/stats/'+this.userData.id)

    Promise.all([listaUtenti,infoHome]).then(response => {
      if(response[0].data.statusCode===200){
        //caricamento lista utenti
        this.lista_utenti = response[0].data.reply.dati
        
        if(response[1].data.statusCode===200){
          //caricamento info statiche
          this.statistiche = response[1].data.reply
          
          this.Caricato = true;
          this.errore_caricamento = false;
          
        } else {
          this.Caricato = false;
          this.errore_caricamento = true;
        }
        
      } else {
        this.Caricato = false;
        this.errore_caricamento = true;
      }
        
    })
  },
  methods: {
    controlloStatoUtenti() {
      console.log("controlloStatoUtenti in Home - start 222")
      this.Caricato = false;
      this.errore_caricamento = false;

      this.$http.get('api/crm/user/list_availabilities').then(response => { 
        if(response.data.statusCode == 200){
          //caricamento lista utenti
          this.lista_utenti = response.data.reply.dati
          
          this.Caricato = true;
          this.errore_caricamento = false;
        } else {
          this.Caricato = false;
          this.errore_caricamento = true;
        }
      });

    },
    stopInterval() {
      clearInterval(this.intervalId); // Ferma l'intervallo
      this.intervalId = null;
      console.log("Intervallo controllo stato utenti fermato.");
    },
  },
  mounted() {
    // Avvia l'intervallo
    this.intervalId = setInterval(this.controlloStatoUtenti, 5000); // Ogni 5 secondi
    //console.log("Intervallo avviato.");
  },
  beforeRouteLeave(to, from, next) {
    //console.log("Prima di lasciare la pagina:", from.fullPath, "->", to.fullPath);

    //console.log("beforeRouteLeave --------------------")
    // Pulisce l'intervallo quando il componente viene distrutto
    clearInterval(this.intervalId);

    this.stopInterval();

    //console.log("beforeRouteLeave - prima cambio pagina --------------------")

    next(); //cambio pagina
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';

@media (max-width: 1200px) {
  .posizione_mobile {
    margin-left: 68px;
  }
}
</style>
